import { useContext } from 'react';
import { Header, AppLayout, ContentLayout, Grid } from '@cloudscape-design/components';

import { LocalNavigation, Breadcrumbs, NavigationContext } from '../common/navigation';

import FreeSubscriptionInfo from './free';
import PlusSubscriptionInfo from './plus';

export default function SubscriptionView() {
  const { navigationSize, navigationOpen, setNavigationOpen } = useContext(NavigationContext);

  return (
    <AppLayout
      breadcrumbs={<Breadcrumbs items={[{ text: 'Plans', href: '' }]} />}
      className="app-layout"
      content={
        <ContentLayout header={<Header variant="h1">Escape Plans</Header>}>
          <Grid
            gridDefinition={[
              {
                colspan: {
                  default: 12,
                  l: 5,
                  s: 5,
                },
              },
              {
                colspan: {
                  default: 12,
                  l: 5,
                  s: 5,
                },
              },
            ]}
          >
            <FreeSubscriptionInfo />
            <PlusSubscriptionInfo />
          </Grid>
        </ContentLayout>
      }
      contentType="default"
      headerSelector=".top-navigation"
      navigation={<LocalNavigation />}
      navigationOpen={navigationOpen}
      navigationWidth={navigationSize}
      toolsHide
      onNavigationChange={(event) => setNavigationOpen(event.detail.open)}
    />
  );
}
